import axios from "axios";
import { ChargeResponse, CryptoConfigResponse } from "@/api/types";

export type GuestProduct = 'basic' | 'advanced';
export type GuestTerm = 'monthly' | 'lifetime';

export interface GuestCheckoutDetails {
    client_id: string;
    mode: string;
    currency: string;
    basic: Record<GuestTerm, number>;
    advanced: Record<GuestTerm, number>;
}

export interface GuestOrderResponse {
    id: string;
    checkout_token: string;
}

export interface GuestDiscountResponse {
    amount: number;
    original_price: number;
    price: number;
    currency: string;
}

export interface GuestCaptureResponse {
    status: 'ready';
    claim_url: string;
}

export const getDetails = () =>
    axios.get<GuestCheckoutDetails>('guest-checkout/details');

export const getDiscount = (product: GuestProduct, code: string) =>
    axios.post<GuestDiscountResponse>('guest-checkout/discount', { product, code });

export const createOrder = (email: string, plan: string, discount = '') =>
    axios.post<GuestOrderResponse>('guest-checkout/order', { email, plan, discount });

export const createSubscription = (email: string, plan: string) =>
    axios.post<GuestOrderResponse>('guest-checkout/subscription', { email, plan });

export const capture = (checkoutToken: string, orderId: string) =>
    axios.post<GuestCaptureResponse>('guest-checkout/capture', {
        checkout_token: checkoutToken,
        order_id: orderId,
    });

export const getCryptoConfig = () =>
    axios.get<CryptoConfigResponse>('guest-checkout/crypto/config');

export const getCryptoCurrencies = () =>
    axios.get<string[]>('guest-checkout/crypto/currencies');

export const createCryptoPayment = (
    email: string,
    product: GuestProduct,
    payCurrency: string,
    discount = '',
    sandboxCase?: string,
    term: GuestTerm = 'lifetime',
) => axios.post<ChargeResponse & { checkout_token: string }>('guest-checkout/crypto/payment', {
    email,
    product,
    term,
    pay_currency: payCurrency,
    discount,
    ...(sandboxCase ? { case: sandboxCase } : {}),
});

export const getCryptoStatus = (checkoutToken: string, paymentId: string) =>
    axios.get<ChargeResponse & { claim_url?: string }>(`guest-checkout/crypto/status/${paymentId}`, {
        params: { checkout_token: checkoutToken },
    });

export const claim = (
    checkoutToken: string,
    email: string,
    username: string,
    password: string,
    passwordConfirmation: string,
) => axios.post<{ access_token: string }>('guest-checkout/claim', {
    checkout_token: checkoutToken,
    email,
    username,
    password,
    password_confirmation: passwordConfirmation,
});
